import React from 'react';

const WHATSAPP_URL = `https://wa.me/919007396826?text=${encodeURIComponent(
  "Hello G.A ISPAT PVT LTD, I would like to enquire about your steel products."
)}`;

const WhatsAppButton = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 left-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-30"></span>
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110">
        <svg viewBox="0 0 32 32" className="w-8 h-8 fill-white" aria-hidden="true">
          <path d="M16.004 3C9.383 3 4 8.383 4 15.004c0 2.648.87 5.103 2.34 7.09L4.5 28.5l6.594-1.797a11.93 11.93 0 0 0 4.91 1.05h.005C22.625 27.753 28 22.37 28 15.75 28 8.383 22.625 3 16.004 3zm0 22.508h-.004a9.93 9.93 0 0 1-4.523-1.148l-.324-.176-3.914 1.066 1.05-3.813-.21-.336a9.9 9.9 0 0 1-1.575-5.098c0-5.508 4.492-10 10.004-10 5.508 0 9.996 4.492 9.996 10.004 0 5.508-4.488 9.996-10 9.996zm5.484-7.469c-.3-.15-1.777-.879-2.052-.98-.274-.098-.476-.148-.675.152-.2.297-.777.977-.953 1.176-.176.199-.352.223-.652.074-.301-.152-1.27-.469-2.418-1.492-.895-.797-1.5-1.781-1.676-2.082-.176-.297-.02-.457.132-.606.137-.136.301-.351.454-.527.148-.176.199-.301.297-.5.101-.199.05-.375-.024-.527-.074-.148-.675-1.625-.925-2.227-.242-.578-.489-.5-.675-.508-.176-.008-.375-.011-.575-.011s-.523.074-.797.375c-.273.297-1.047 1.023-1.047 2.5 0 1.472 1.07 2.898 1.223 3.097.148.199 2.105 3.215 5.101 4.508.715.309 1.27.492 1.704.633.715.226 1.367.195 1.882.117.575-.086 1.777-.727 2.028-1.43.25-.703.25-1.304.176-1.43-.074-.124-.274-.198-.575-.35z" />
        </svg>
      </span>
      <span className="absolute left-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-slate-800 text-white text-xs font-medium px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none shadow-lg">
        Chat with us on WhatsApp
      </span>
    </a>
  );
};

export default WhatsAppButton;
